import React, { useState, useEffect } from "react";
import axios from "axios";
import { Container, Row, Offcanvas } from "react-bootstrap";
import "../Wallet/WalletTransactions.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function WalletTransactions() {
  const [activeTab, setActiveTab] = useState("withdraw"); // default to 'withdraw' or 'topup'

  const [isMarketFrozen, setIsMarketFrozen] = useState(false);
  const [freezeMessage, setFreezeMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const fetchMarketStatus = async () => {
    setIsLoading(true); // Start loader
    try {
      const Token = localStorage.getItem("user_token");
      const response = await axios.get(
        "https://toptennis.io/api/users/market-status",
        {
          headers: { Authorization: `Bearer ${Token}` },
        }
      );

      // Extract values from the API response
      const { isFrozen, bannerText } = response.data;

      // Update state with both values
      setIsMarketFrozen(isFrozen);
      setFreezeMessage(bannerText || ""); // Ensure it's not undefined
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching market status:", error);
    } finally {
      setIsLoading(false); // Ensure loader stops after API response
    }
  };

  useEffect(() => {
    fetchMarketStatus();
  }, []);

  const navigate = useNavigate();

  // const [players, setPlayers] = useState([]);

  // useEffect(() => {
  //   const fetchPlayersAndMergeData = async () => {
  //     const Token = localStorage.getItem("user_token");

  //     try {
  //       // Decode user ID from token
  //       const decodedToken = JSON.parse(atob(Token.split(".")[1]));
  //       const userId = decodedToken._id;

  //       // Fetch data from API
  //       const response = await axios.get(
  //         `https://toptennis.io/api/users/selected-teamlist/${userId}`,
  //         { headers: { Authorization: `Bearer ${Token}` } }
  //       );

  //       if (response.data && response.data.status) {
  //         const { team, valueDifferences } = response.data;

  //         // Create a map of valueDifferences by `player_id`
  //         const valueDifferenceMap = valueDifferences.reduce(
  //           (acc, valueDifference) => {
  //             acc[valueDifference.player_id] = valueDifference;
  //             return acc;
  //           },
  //           {}
  //         );

  //         // Merge team.players with valueDifferences
  //         const mergedData = team.players.map((player) => {
  //           const differenceData = valueDifferenceMap[player._id] || {};

  //           return {
  //             ...player,
  //             currentValue: differenceData.value || player.value, // Value from valueDifferences if available
  //             valueDifference: differenceData.valueDifference || 0, // Value difference if available
  //           };
  //         });

  //         // Update state with merged data
  //         setPlayers(mergedData);
  //         console.log("Merged Data:", mergedData); // Debugging merged data
  //       } else {
  //         console.error("Unexpected response format", response.data);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching data:", error);
  //     }
  //   };

  //   fetchPlayersAndMergeData();
  // }, []);

  const [show1, setShow1] = useState(false);
  const [differenceValue, setDifferenceValue] = useState(0);
  const [playerval, setplayerval] = useState(0);
  const [inPlayValue, setInPlayValue] = useState(0);
  const [credits, setCredits] = useState(0);
  const [userName, setUserName] = useState("");
  const [totalSpent, setTotalSpent] = useState(0);

  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);
  const fetchUserValues = async () => {
    const Token = localStorage.getItem("user_token");

    if (Token) {
      const decodedToken = JSON.parse(atob(Token.split(".")[1]));
      const userId = decodedToken._id;

      try {
        // Fetch user in-play values
        const response = await axios.get(
          `https://toptennis.io/api/users/user/in-play-value/${userId}`,
          {
            headers: { Authorization: `Bearer ${Token}` },
          }
        );

        const {
          name,
          credits,
          grand_total_value,
          player_value_sum,
          differenceValue,
          latest_inc,
        } = response.data;

        setUserName(name);
        setCredits(credits);
        setInPlayValue(grand_total_value);
        setTotalSpent(player_value_sum);
        setDifferenceValue(differenceValue);
        setplayerval(latest_inc);
      } catch (error) {
        console.error("Error fetching in-play values:", error);
      }
    }
  };

  useEffect(() => {
    fetchUserValues();
  }, []);

  const [amount, setAmount] = useState("");
  const [walletAddress, setWalletAddress] = useState("");
  const [photoID, setPhotoID] = useState(null);
  const [proofOfAddress, setProofOfAddress] = useState(null);
  const [network, setNetwork] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = async () => {
    if (!email) {
      setMessage("Please enter a valid email.");
      return;
    }

    try {
      const response = await fetch(
        "https://api.convertkit.com/v3/forms/7878458/subscribe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            api_key: "3bkwOyREXJsvpFPZ5iUAAw",
            email: email,
          }),
        }
      );

      const data = await response.json();
      if (data.subscription) {
        setMessage(
          "Success! Please check your email to confirm your subscription."
        );
        setEmail(""); // Clear input
      } else {
        setMessage(data.message || "Something went wrong.");
      }
    } catch (error) {
      setMessage("Subscription failed. Please try again later.");
      console.error(error);
    }
  };

  const handleEmailClick = () => {
    const email = "contact@toptennis.io";
    const subject = "";
    const body = "";
    const url = `https://mail.google.com/mail/?view=cm&to=${email}&su=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
    window.open(url, "_blank");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Start loading

    const Token = localStorage.getItem("user_token");

    if (!Token) {
      console.error("No token found");
      setIsSubmitting(false); // Stop loading
      return;
    }

    const withdrawalAmount = parseFloat(amount);
    const requestData = {
      amount: withdrawalAmount,
      walletAddress,
      network: network,
    };

    // Validate required files for amount >= 1000
    if (withdrawalAmount >= 1000) {
      if (!photoID || !proofOfAddress) {
        Swal.fire({
          icon: "warning",
          title: "Documents Required",
          text: "For withdrawals of 1000 or more, both Photo ID and Proof of Address are required.",
          confirmButtonColor: "#f39c12",
        });
        setIsSubmitting(false); // Stop loading
        return; // Stop the form submission
      }
    }

    const formData = new FormData();
    formData.append("amount", requestData.amount);
    formData.append("walletAddress", requestData.walletAddress);
    formData.append("network", requestData.network);

    if (withdrawalAmount >= 1000) {
      formData.append("photoID", photoID);
      formData.append("proofOfAddress", proofOfAddress);
    }

    try {
      const response = await axios.post(
        "https://toptennis.io/api/users/withdrawreq",
        formData,
        {
          headers: {
            authorization: `Bearer ${Token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data) {
        Swal.fire({
          icon: "success",
          title: "Withdrawal Request Submitted",
          text: "Thank you. Your request has been received. If we require any further information, we will let you know. Otherwise, you will receive confirmation once your request has been processed.",
          confirmButtonColor: "#3085d6",
        });

        fetchUserValues();
        setAmount("");
        setWalletAddress("");
        setNetwork("");
        setPhotoID(null);
        setProofOfAddress(null);
      }
    } catch (error) {
      console.error("Error submitting withdrawal request:", error);
      if (withdrawalAmount > credits) {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "You can withdraw up to your available credit balance. Please try again.",
          confirmButtonColor: "#d33",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "There was an error submitting your withdrawal request. Please try again later.",
          confirmButtonColor: "#d33",
        });
      }
    } finally {
      setIsSubmitting(false); // Stop loading regardless of success or failure
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("user_token");
    localStorage.removeItem("fullName");
    localStorage.removeItem("userId");
    localStorage.removeItem("user_isfrozen");
    localStorage.removeItem("email");
    console.log("User logged out successfully.");
    navigate("/");
  };

  return (
    <>
      {isLoading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
      <Container
        className="justify-content-center align-items-center cn"
        // style={{ paddingTop: "160px"}}
      >
        <Row className="w-100 justify-content-center rowdiv">
          <div className="freeze-banner">
            <p>{freezeMessage} </p>
          </div>

          <div className="user-info">
            <button
              variant="light"
              className="d-md-none menu-btn "
              onClick={handleShow1}
            >
              ☰ {/* Hamburger Icon */}
            </button>
            <div className="left-section1 d-flex1">
              <span className="welcome-text">Welcome, {userName}</span>
              <div className="top-navigation d-none d-md-flex">
                <span className="nav-item" onClick={() => navigate("/home")}>
                  Home
                </span>
                <span
                  className="nav-item active"
                  onClick={() => navigate("/profile")}
                >
                  Profile
                </span>
                <span className="nav-item" onClick={() => navigate("/myteam")}>
                  My Team
                </span>
                <span className="nav-item" onClick={() => navigate("/faq")}>
                  FAQs
                </span>
                <span className="nav-item" onClick={() => navigate("/news")}>
                  News
                </span>
                <span className="nav-item" onClick={handleLogout}>
                  Logout
                </span>
              </div>
            </div>

            <Offcanvas show={show1} onHide={handleClose1} placement="start">
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>Menu</Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <div className="mobile-nav">
                  <span
                    className="nav-item "
                    onClick={() => {
                      navigate("/home");
                      handleClose1();
                    }}
                  >
                    Home
                  </span>
                  <span
                    className="nav-item active"
                    onClick={() => {
                      navigate("/profile");
                      handleClose1();
                    }}
                  >
                    Profile
                  </span>
                  <span
                    className="nav-item "
                    onClick={() => {
                      navigate("/myteam");
                      handleClose1();
                    }}
                  >
                    My Team
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      navigate("/faq");
                      handleClose1();
                    }}
                  >
                    FAQs
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      navigate("/faq");
                      handleClose1();
                    }}
                  >
                    News
                  </span>
                  <span
                    className="nav-item"
                    onClick={() => {
                      handleLogout();
                      handleClose1();
                    }}
                  >
                    Logout
                  </span>
                </div>
              </Offcanvas.Body>
            </Offcanvas>

            {/* <div className="right-section1">
              <div className="credit-box">
                <p className="p">
                  Credit available: <span>{credits.toFixed(2)}</span>
                </p>
                <p className="p">
                  In-play: <span>{inPlayValue.toFixed(2)}</span>
                </p>
                <p className="p">
                  Current Team P/L:&nbsp;
                  <span
                    // style={{ color: Number(differenceValue) >= 0 ? "green" : "red" }}>
                    style={{
                      color:
                        Number(differenceValue) > 0
                          ? "green"
                          : Number(differenceValue) < 0
                          ? "red"
                          : "black",
                    }}
                  >
                    {differenceValue
                      ? Number(differenceValue) > 0
                        ? `+${Number(differenceValue).toFixed(2)}`
                        : Number(differenceValue).toFixed(2)
                      : "0.00"}
                  </span>
                </p>
              </div>
            </div> */}
            <div className="right-section1">
              <div className="credit-box-container">
                <button
                  className="topup-button"
                  onClick={() => {
                    navigate("/topup");
                  }}
                >
                  Top-up
                </button>
                <div className="credit-box">
                  <p className="p">
                    Credit available: <span>{credits?.toFixed(2)}</span>
                  </p>
                  <p className="p">
                    In-play: <span>{inPlayValue.toFixed(2)}</span>
                  </p>
                  <p className="p">
                    Current Team P/L:&nbsp;
                    <span
                      style={{
                        color:
                          Number(differenceValue) > 0
                            ? "green"
                            : Number(differenceValue) < 0
                            ? "red"
                            : "black",
                      }}
                    >
                      {differenceValue
                        ? Number(differenceValue) > 0
                          ? `+${Number(differenceValue).toFixed(2)}`
                          : Number(differenceValue).toFixed(2)
                        : "0.00"}
                    </span>
                    &nbsp;
                    {/* <span className="pl-inc">
                      (Inc&nbsp;
                      <span
                        style={{
                          color:
                            Number(playerval) > 0
                              ? "green"
                              : Number(playerval) < 0
                              ? "red"
                              : "black",
                        }}
                      >
                        {playerval
                          ? Number(playerval) > 0
                            ? `+${Number(playerval).toFixed(2)}`
                            : Number(playerval).toFixed(2)
                          : "0.00"}
                      </span>
                      )
                    </span> */}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </Row>
        <div className="top-nav">
          {/* <span className="top-up">Top-up</span>
            <span className="withdraw-selected">Withdraw</span> */}
          <span
            className={`top-up ${activeTab === "topup" ? "active" : ""}`}
            onClick={() => {
              setActiveTab("topup");
              navigate("/topup");
            }}
          >
            Top-up
          </span>
          <span
            className={`withdraw-selected ${
              activeTab === "withdraw" ? "active" : ""
            }`}
            onClick={() => {
              setActiveTab("withdraw");
              navigate("/withdraw");
            }}
          >
            Withdraw
          </span>
        </div>
        <div className="withdraw-container">
          <form className="withdraw-form" onSubmit={handleSubmit}>
            <div className="left-sectionn1">
              <p className="description">
                To make a withdrawal, please enter the amount you wish to
                withdraw (up to your total credit available) and your wallet
                address.
              </p>
              <p className="rate">1 credit = 0.1 USDT*</p>

              <div>
                <label className="label">Amount (of credits)</label>
                <input
                  type="text"
                  className="input"
                  value={amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Allow only numbers with up to 2 decimal places
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setAmount(value);
                    }
                  }}
                  required
                />
              </div>
              <div>
                <label className="label">Your USDT wallet address</label>
                <input
                  type="text"
                  className="input"
                  value={walletAddress}
                  onChange={(e) => setWalletAddress(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="label">Network</label>
                <select
                  className="input"
                  value={network}
                  onChange={(e) => setNetwork(e.target.value)}
                  required
                >
                  <option value="">Select Network</option>
                  <option value="Ethereum (ERC20)">Ethereum (ERC20)</option>
                  <option value="BNB Smart Chain (BEP20)">
                    BNB Smart Chain (BEP20)
                  </option>
                  <option value="Tron (TRC20)">Tron (TRC20)</option>
                </select>
              </div>
              <p className="note">
                *there is a 2% withdrawal fee to cover network send costs
              </p>
            </div>

            {parseFloat(amount) > 1000 && (
              <div className="right-sectionn1">
                <p className="info-text">
                  If you are withdrawing more than 1000 credits within a 12
                  month period, additional checks are required for anti-money
                  laundering requirements. All documents are securely stored.
                </p>

                <label className="label">
                  Government-issued photographic ID
                </label>
                <input
                  type="file"
                  className="file-input"
                  onChange={(e) => setPhotoID(e.target.files[0])}
                />

                <label className="label">
                  Proof of address (dated within the last 6 months)
                </label>
                <input
                  type="file"
                  className="file-input"
                  onChange={(e) => setProofOfAddress(e.target.files[0])}
                />
              </div>
            )}

            <button type="submit" className="withdraw-submit-btn" disabled={isSubmitting}>
              {isSubmitting ? (
                <div className="withdraw-loader-container">
                  <div className="withdraw-loader"></div>
                  <span>Processing...</span>
                </div>
              ) : (
                "SUBMIT"
              )}
            </button>
          </form>
        </div>
        <div className="card-footer3">
          <div className="footer">
            <div className="footer-firstline">
              <div className="footer-sub">
                <h4>Keep in touch</h4>
                <h5>Join our newsletter. We promise not to spam!</h5>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="footer-input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                />
                <button className="subscribe-btn" onClick={handleSubscribe}>
                  Subscribe
                </button>
                {message && (
                  <p style={{ marginTop: "10px", marginLeft: "5px" }}>
                    {message}
                  </p>
                )}
              </div>

              <div className="footer-sub1">
                <h4>Quick links</h4>
                <a href="/home" className="footer-link">
                  Home
                </a>
                <a href="/profile" className="footer-link">
                  Profile
                </a>
                <a href="/myteam" className="footer-link">
                  My Team
                </a>
                <a href="/news" className="footer-link">
                  News
                </a>
                <a href="/faq" className="footer-link">
                  FAQs
                </a>
                {/* <a
                  onClick={handleEmailClick}
                  className="footer-link"
                  style={{ cursor: "pointer" }}
                >
                  Support
                </a> */}
              </div>

              <div className="footer-sub1 secondicon">
                <h4>Socials</h4>
                <div className="social-icons">
                  <a
                    href="https://www.facebook.com/toptennisio/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-facebook-f"></i>
                  </a>
                  <a
                    href="https://www.instagram.com/toptennisuk"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-circle"
                    style={{ textDecoration: "none" }}
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </div>
                <div className="fl1">
                  <a
                    href="/terms"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    T&Cs
                  </a>
                  <a
                    href="/privacy"
                    className="footer-link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Privacy Policy
                  </a>
                    <span className="footer-link">
                      Email: contact@toptennis.io
                    </span>
                </div>
              </div>
              {/* </div> */}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
}

export default WalletTransactions;
